(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function initMobileMenuCloseAndSwipe() {
      var wrapper = document.querySelector('.sf-menu-wrapper-mobile');
      var panel = wrapper && wrapper.querySelector('.sf-menu__content');

      if (!wrapper || !panel) return;

      function closeMobileMenu() {
        wrapper.dispatchEvent(new MouseEvent('click', { bubbles: false, cancelable: true }));
      }

      var closeBtn = panel.querySelector('.sf-menu-close-btn');
      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          closeMobileMenu();
        });
      }

      var touchStartX = null;
      var touchStartY = null;
      var SWIPE_THRESHOLD = 60;

      panel.addEventListener(
        'touchstart',
        function (e) {
          if (e.touches.length !== 1) return;
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        },
        { passive: true }
      );

      panel.addEventListener(
        'touchend',
        function (e) {
          if (touchStartX === null) return;

          var touch = e.changedTouches[0];
          var deltaX = touch.clientX - touchStartX;
          var deltaY = touch.clientY - touchStartY;

          touchStartX = null;
          touchStartY = null;

          if (deltaX < -SWIPE_THRESHOLD && Math.abs(deltaX) > Math.abs(deltaY)) {
            closeMobileMenu();
          }
        },
        { passive: true }
      );
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMobileMenuCloseAndSwipe);
    } else {
      initMobileMenuCloseAndSwipe();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tv-clan-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.__tvxClan) return;
      root.__tvxClan = true;

      var input = root.querySelector('[data-clan-search]');
      var clear = root.querySelector('[data-clan-clear]');
      var status = root.querySelector('[data-clan-status]');
      var empty = root.querySelector('[data-clan-empty]');
      var letters = Array.prototype.slice.call(root.querySelectorAll('[data-clan-letter]'));
      var groups = Array.prototype.slice.call(root.querySelectorAll('[data-clan-group]'));
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-clan-key]'));
      var initialStatus = status ? status.textContent : '';
      if (!input || !groups.length) return;

      function isMobile() { return window.matchMedia('(max-width: 749px)').matches; }

      function selectLetter(key) {
        letters.forEach(function (btn) {
          btn.setAttribute('aria-selected', btn.getAttribute('data-clan-letter') === key ? 'true' : 'false');
        });
        groups.forEach(function (g) {
          g.classList.toggle('is-active', g.getAttribute('data-clan-group') === key);
        });
      }

      function openGroup(key) {
        groups.forEach(function (g) {
          var open = g.getAttribute('data-clan-group') === key;
          g.classList.toggle('is-open', open);
          var t = g.querySelector('.tvx-clan__trigger');
          if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }

      letters.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-clan-letter');
          selectLetter(key);
          if (isMobile()) openGroup(key);
        });
      });

      groups.forEach(function (g) {
        var t = g.querySelector('.tvx-clan__trigger');
        if (!t) return;
        t.addEventListener('click', function () {
          if (root.classList.contains('is-searching')) return;
          var willOpen = !g.classList.contains('is-open');
          openGroup(willOpen ? g.getAttribute('data-clan-group') : null);
          if (willOpen) {
            var sticky = 0;
            document.querySelectorAll('.tvx-section-ptabs, .tvx-section-nav').forEach(function (el) {
              if (getComputedStyle(el).position === 'sticky') sticky += el.offsetHeight;
            });
            var top = g.getBoundingClientRect().top + window.pageYOffset - sticky - 8;
            if (g.getBoundingClientRect().top < sticky) window.scrollTo({ top: top, behavior: 'smooth' });
          }
        });
      });

      function runSearch() {
        var q = (input.value || '').toLowerCase().replace(/['\u2019.]/g, '').replace(/-/g, ' ').trim();
        var searching = q.length > 0;
        root.classList.toggle('is-searching', searching);

        if (!searching) {
          items.forEach(function (a) { a.parentNode.hidden = false; });
          groups.forEach(function (g) {
            g.classList.remove('has-match');
            var c = g.querySelector('.tvx-clan__count');
            if (c) c.textContent = c.getAttribute('data-total');
          });
          if (status) status.textContent = initialStatus;
          if (empty) empty.hidden = true;
          return;
        }

        var total = 0;
        groups.forEach(function (g) {
          var found = 0;
          g.querySelectorAll('[data-clan-key]').forEach(function (a) {
            var hit = a.getAttribute('data-clan-key').indexOf(q) > -1;
            a.parentNode.hidden = !hit;
            if (hit) found++;
          });
          g.classList.toggle('has-match', found > 0);
          var c = g.querySelector('.tvx-clan__count');
          if (c) c.textContent = found;
          total += found;
        });
        if (status) status.textContent = total === 1 ? '1 match' : total + ' matches';
        if (empty) empty.hidden = total > 0;
      }

      var timer;
      function onInput() { clearTimeout(timer); timer = setTimeout(runSearch, 120); }
      input.addEventListener('input', onInput);
      input.addEventListener('search', onInput);
      if (clear) {
        clear.addEventListener('click', function () {
          input.value = '';
          runSearch();
          input.focus();
        });
      }

      selectLetter(root.getAttribute('data-default-group') || '');
    }

    function boot() { document.querySelectorAll('[data-tvx-clan]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tv-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.tvxFaqReady === '1') return;
      root.dataset.tvxFaqReady = '1';
      var items = Array.prototype.slice.call(root.querySelectorAll('.tvx-faq__item'));
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          if (root.dataset.single !== 'true') return;
          items.forEach(function (other) {
            if (other !== item && other.open) other.open = false;
          });
        });
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-tvx-faq]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });

    document.addEventListener('shopify:block:select', function (event) {
      var item = event.target.closest ? event.target.closest('.tvx-faq__item') : null;
      if (!item) item = event.target.querySelector ? event.target.querySelector('.tvx-faq__item') : null;
      if (item) item.open = true;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tv-hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__tvxHeroScroll) return;
    window.__tvxHeroScroll = true;

    function visible(el) {
      return !!el && el.offsetHeight > 0 && getComputedStyle(el).display !== 'none';
    }

    function stickyOffset() {
      var offset = 0;
      var nodes = document.querySelectorAll('.shopify-section, .shopify-section-group-header-group, header');
      nodes.forEach(function (el) {
        if (!visible(el)) return;
        var cs = getComputedStyle(el);
        if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
        var top = parseFloat(cs.top);
        if (isNaN(top) || top > window.innerHeight / 3) return;
        offset = Math.max(offset, top + el.offsetHeight);
      });
      return offset;
    }

    function nextSection(from) {
      var wrap = from.closest('.shopify-section') || from;
      var el = wrap.nextElementSibling;
      while (el) {
        if (visible(el)) {
          var pos = getComputedStyle(el).position;
          if (pos !== 'sticky' && pos !== 'fixed') return el;
        }
        el = el.nextElementSibling;
      }
      return null;
    }

    document.addEventListener('click', function (e) {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var btn = e.target.closest && e.target.closest('[data-tvx-hero-scroll]');
      if (!btn) return;
      var mode = btn.getAttribute('data-tvx-hero-scroll');
      var target = null;
      if (mode === 'anchor') target = document.getElementById(btn.getAttribute('data-tvx-hero-target'));
      if (!visible(target)) target = nextSection(btn);
      if (!target) return;
      e.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var y = target.getBoundingClientRect().top + window.pageYOffset - stickyOffset();
      window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
      var focusEl = target.querySelector('h1, h2, h3, a, button, input') || target;
      setTimeout(function () {
        if (!focusEl.hasAttribute('tabindex') && !/^(A|BUTTON|INPUT)$/.test(focusEl.tagName)) focusEl.setAttribute('tabindex', '-1');
        try { focusEl.focus({ preventScroll: true }); } catch (err) {}
      }, reduce ? 0 : 500);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tv-hero-split"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('tv-hero-slider')) return;

    class TvHeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.tv-hs__slide'));
        this.track = this.querySelector('.tv-hs__track');
        this.viewport = this.querySelector('.tv-hs__viewport');
        this.dots = Array.from(this.querySelectorAll('[data-hs-dot]'));
        this.toggle = this.querySelector('[data-hs-toggle]');
        this.index = 0;
        this.speed = (Number(this.dataset.speed) || 6) * 1000;
        this.remaining = this.speed;
        this.holds = new Set();
        this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
        this.userPaused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.slides.length < 2) return;

        this.querySelectorAll('[data-hs-prev]').forEach((button) => button.addEventListener('click', () => this.go(this.index - 1)));
        this.querySelectorAll('[data-hs-next]').forEach((button) => button.addEventListener('click', () => this.go(this.index + 1)));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.hsDot))));
        if (this.toggle) this.toggle.addEventListener('click', () => this.togglePlay());

        this.addEventListener('keydown', (event) => {
          if (!event.target.closest('.tv-hs__controls')) return;
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(this.index - 1);
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.go(this.index + 1);
          }
        });

        this.viewport.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse') return;
          this.startX = event.clientX;
          this.startY = event.clientY;
        });
        this.viewport.addEventListener('pointerup', (event) => {
          if (this.startX === undefined) return;
          const dx = event.clientX - this.startX;
          const dy = event.clientY - this.startY;
          this.startX = undefined;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.2) this.go(this.index + (dx < 0 ? 1 : -1));
        });
        this.viewport.addEventListener('pointercancel', () => {
          this.startX = undefined;
        });

        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('.tv-hs__slide');
          const index = this.slides.indexOf(slide);
          if (index > -1) this.go(index);
          this.hold('editor');
        });
        this.addEventListener('shopify:block:deselect', () => this.release('editor'));

        if (this.autoplay) {
          if (window.matchMedia('(hover: hover)').matches) {
            this.addEventListener('mouseenter', () => this.hold('hover'));
            this.addEventListener('mouseleave', () => this.release('hover'));
          }
          this.addEventListener('focusin', () => this.hold('focus'));
          this.addEventListener('focusout', (event) => {
            if (!this.contains(event.relatedTarget)) this.release('focus');
          });
          this.onVisibility = () => (document.hidden ? this.hold('hidden') : this.release('hidden'));
          document.addEventListener('visibilitychange', this.onVisibility);
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => (entry.isIntersecting ? this.release('offscreen') : this.hold('offscreen')));
          }, { threshold: 0.2 });
          this.observer.observe(this);
          this.classList.toggle('is-user-paused', this.userPaused);
          this.updateToggle();
        }

        this.update();
        this.play();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.observer) this.observer.disconnect();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      }

      go(target) {
        const count = this.slides.length;
        this.index = (target + count) % count;
        this.remaining = this.speed;
        this.update();
        if (this.classList.contains('is-playing')) this.schedule(this.speed);
      }

      update() {
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('inert', !active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        this.track.style.setProperty('--hs-index', this.index);
        this.dots.forEach((dot, i) => {
          const active = i === this.index;
          dot.classList.remove('is-active');
          if (active) {
            void dot.offsetWidth;
            dot.classList.add('is-active');
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
        const next = this.slides[(this.index + 1) % this.slides.length];
        next.querySelectorAll('img[loading="lazy"]').forEach((img) => {
          img.loading = 'eager';
        });
      }

      schedule(ms) {
        clearTimeout(this.timer);
        this.started = performance.now();
        this.remaining = ms;
        this.timer = setTimeout(() => this.go(this.index + 1), ms);
      }

      play() {
        if (!this.autoplay || this.userPaused || this.holds.size) {
          this.classList.remove('is-playing');
          this.track.setAttribute('aria-live', 'polite');
          return;
        }
        if (this.classList.contains('is-playing')) return;
        this.classList.add('is-playing');
        this.track.setAttribute('aria-live', 'off');
        this.schedule(this.remaining || this.speed);
      }

      pause() {
        if (!this.classList.contains('is-playing')) return;
        clearTimeout(this.timer);
        this.remaining = Math.max(400, this.remaining - (performance.now() - this.started));
        this.classList.remove('is-playing');
        this.track.setAttribute('aria-live', 'polite');
      }

      hold(reason) {
        this.holds.add(reason);
        this.pause();
      }

      release(reason) {
        this.holds.delete(reason);
        this.play();
      }

      togglePlay() {
        this.userPaused = !this.userPaused;
        this.classList.toggle('is-user-paused', this.userPaused);
        if (this.userPaused) {
          this.pause();
        } else {
          this.holds.delete('hover');
          this.holds.delete('focus');
          this.play();
        }
        this.updateToggle();
      }

      updateToggle() {
        if (!this.toggle) return;
        this.toggle.setAttribute('aria-label', this.userPaused ? 'Play slideshow' : 'Pause slideshow');
      }
    }

    customElements.define('tv-hero-slider', TvHeroSlider);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tv-jump-menu"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(nav) {
      if (!nav || nav.__tvxReady) return;
      nav.__tvxReady = true;

      var links = Array.prototype.slice.call(nav.querySelectorAll('a.tvx-nav__link'));
      var items = [];
      links.forEach(function (a) {
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) !== '#' || href.length < 2) return;
        var target = document.getElementById(decodeURIComponent(href.slice(1)));
        if (!target) return;
        items.push({ a: a, t: target });
        a.addEventListener('click', function (e) {
          e.preventDefault();
          target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
          if (history.replaceState) history.replaceState(null, '', href);
        });
      });
      if (!items.length) return;

      var list = nav.querySelector('.tvx-nav__list');
      var current = null;
      var ticking = false;

      function setActive(a) {
        items.forEach(function (it) {
          var on = it.a === a;
          it.a.classList.toggle('is-active', on);
          if (on) it.a.setAttribute('aria-current', 'location');
          else it.a.removeAttribute('aria-current');
        });
        if (a && list && list.scrollWidth > list.clientWidth) {
          list.scrollTo({ left: a.parentNode.offsetLeft - (list.clientWidth - a.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
        }
      }

      function update() {
        ticking = false;
        if (!nav.isConnected) { window.removeEventListener('scroll', onScroll); return; }
        var navBottom = nav.getBoundingClientRect().bottom;
        var line = Math.max(navBottom + 80, window.innerHeight * 0.4);
        var found = null;
        items.forEach(function (it) {
          var r = it.t.getBoundingClientRect();
          if (r.top <= line && r.bottom > navBottom) found = it.a;
        });
        if (found !== current) { current = found; setActive(found); }
      }

      function onScroll() {
        if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      update();
    }

    function initAll() {
      document.querySelectorAll('.tvx-nav').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tv-page-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__tvxPageTabs) return;
    window.__tvxPageTabs = true;
    var html = document.documentElement;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function nav() { return document.querySelector('.tvx-ptabs'); }
    function keys() {
      var n = nav(); if (!n) return [];
      return (n.getAttribute('data-tvx-keys') || '').split(',').filter(Boolean);
    }

    function updateFade() {
      var n = nav(); if (!n) return;
      var list = n.querySelector('.tvx-ptabs__list'); if (!list) return;
      var max = list.scrollWidth - list.clientWidth;
      list.classList.toggle('has-more-left', max > 2 && list.scrollLeft > 2);
      list.classList.toggle('has-more-right', max > 2 && list.scrollLeft < max - 2);
    }

    function bindFade() {
      var n = nav(); if (!n) return;
      var list = n.querySelector('.tvx-ptabs__list'); if (!list || list.getAttribute('data-tvx-fade') === '1') return;
      list.setAttribute('data-tvx-fade', '1');
      list.addEventListener('scroll', updateFade, { passive: true });
      window.addEventListener('resize', updateFade);
      updateFade();
      setTimeout(updateFade, 400);
    }

    function syncNav(key) {
      var n = nav(); if (!n) return;
      n.querySelectorAll('.tvx-ptabs__link[data-tvx-tab-link]').forEach(function (a) {
        var on = a.getAttribute('data-tvx-tab-link') === key;
        a.classList.toggle('is-active', on);
        if (on) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current');
        if (on) {
          var list = a.closest('.tvx-ptabs__list');
          if (list && list.scrollWidth > list.clientWidth) {
            list.scrollTo({ left: a.parentNode.offsetLeft - (list.clientWidth - a.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
            setTimeout(updateFade, 450);
          }
        }
      });
    }

    function setTab(key, opts) {
      opts = opts || {};
      var n = nav();
      if (!key || !n || keys().indexOf(key) < 0) return false;
      var changed = html.getAttribute('data-tvx-tab') !== key;
      html.setAttribute('data-tvx-tab', key);
      syncNav(key);

      if (n && opts.push && window.history && history.pushState) {
        var param = n.getAttribute('data-tvx-param') || 'tab';
        var url = new URL(window.location.href);
        if (key === n.getAttribute('data-tvx-default')) url.searchParams.delete(param);
        else url.searchParams.set(param, key);
        url.hash = '';
        history.pushState({ tvxTab: key }, '', url.toString());
      }

      if (changed && n && opts.scroll && n.getAttribute('data-tvx-scroll') === 'true') {
        var wrap = n.parentNode;
        var sib = wrap.nextElementSibling;
        while (sib && sib.offsetHeight === 0) sib = sib.nextElementSibling;
        if (sib) {
          var stickyTop = getComputedStyle(wrap).position === 'sticky' ? (parseFloat(getComputedStyle(wrap).top) || 0) + wrap.offsetHeight : 0;
          var target = sib.getBoundingClientRect().top + window.pageYOffset - stickyTop;
          if (window.pageYOffset > target + 1) {
            window.scrollTo({ top: Math.max(0, target), behavior: reduce ? 'auto' : 'smooth' });
          }
        }
      }

      if (changed) {
        document.dispatchEvent(new CustomEvent('tvx:tab-change', { detail: { tab: key } }));
        window.dispatchEvent(new Event('resize'));
      }
      return true;
    }

    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      var n = nav();
      if (!a || !n || a.target === '_blank') return;
      if ((a.getAttribute('href') || '').charAt(0) === '#' || a.hasAttribute('data-tvx-hero-scroll')) return;
      var key = a.getAttribute('data-tvx-tab-link');
      if (key === null) {
        var url;
        try { url = new URL(a.href, window.location.href); } catch (err) { return; }
        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
        var param = n.getAttribute('data-tvx-param') || 'tab';
        if (url.searchParams.has(param)) key = (url.searchParams.get(param) || '').toLowerCase();
        else if (url.search === '' && url.hash === '') key = n.getAttribute('data-tvx-default');
        else return;
      }
      if (setTab(key, { push: true, scroll: true })) e.preventDefault();
    });

    window.addEventListener('popstate', function () {
      var n = nav(); if (!n) return;
      var param = n.getAttribute('data-tvx-param') || 'tab';
      var v = (new URLSearchParams(window.location.search).get(param) || '').toLowerCase();
      if (!setTab(v)) setTab(n.getAttribute('data-tvx-default'));
    });

    function syncFromHtml() { syncNav(html.getAttribute('data-tvx-tab')); bindFade(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncFromHtml);
    else syncFromHtml();

    document.addEventListener('shopify:section:select', function (e) {
      var pane = e.target && e.target.querySelector && e.target.querySelector(':scope > [data-tvx-pane]');
      if (!pane) return;
      var list = pane.getAttribute('data-tvx-pane').split(' ');
      if (list.indexOf(html.getAttribute('data-tvx-tab')) < 0) setTab(list[0]);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var link = e.target && e.target.querySelector && e.target.querySelector('[data-tvx-tab-link]');
      if (link) setTab(link.getAttribute('data-tvx-tab-link'));
    });
    document.addEventListener('shopify:section:load', function () {
      var cur = html.getAttribute('data-tvx-tab');
      setTimeout(function () { syncNav(cur); bindFade(); updateFade(); }, 0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tv-product-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pageCount(track) {
      var card = track.querySelector('.tvx-card');
      if (!card || !track.clientWidth) return 1;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var step = card.getBoundingClientRect().width + gap;
      var per = Math.max(1, Math.round(track.clientWidth / step));
      return Math.max(1, Math.ceil(track.children.length / per));
    }

    function setupSlider(slider) {
      var track = slider.querySelector('.tvx-pslider__track');
      if (!track) return;
      var dotsWrap = slider.querySelector('.tvx-pslider__dots');
      var arrows = Array.prototype.slice.call(slider.querySelectorAll('.tvx-pslider__arrow'));

      function buildDots() {
        if (!dotsWrap) return;
        var n = pageCount(track);
        if (dotsWrap.children.length === n) return;
        dotsWrap.textContent = '';
        for (var i = 0; i < n; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'tvx-pslider__dot';
          dot.setAttribute('data-index', String(i));
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dotsWrap.appendChild(dot);
        }
      }

      function sync() {
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        slider.classList.toggle('tvx-pslider--static', track.scrollWidth <= track.clientWidth + 2);
        if (dotsWrap && dotsWrap.children.length) {
          var n = dotsWrap.children.length;
          var span = track.scrollWidth - track.clientWidth;
          var i = span > 2 ? Math.round((track.scrollLeft / span) * (n - 1)) : 0;
          i = Math.max(0, Math.min(i, n - 1));
          Array.prototype.forEach.call(dotsWrap.children, function (dot, k) {
            dot.classList.toggle('is-active', k === i);
          });
        }
        arrows.forEach(function (btn) {
          btn.disabled = parseInt(btn.getAttribute('data-tvx-dir'), 10) < 0 ? atStart : atEnd;
        });
      }

      arrows.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.getAttribute('data-tvx-dir'), 10);
          track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
        });
      });

      if (dotsWrap) {
        dotsWrap.addEventListener('click', function (event) {
          var dot = event.target.closest('.tvx-pslider__dot');
          if (!dot) return;
          track.scrollTo({ left: parseInt(dot.getAttribute('data-index'), 10) * track.clientWidth, behavior: 'smooth' });
        });
      }

      var pending = false;
      track.addEventListener('scroll', function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; sync(); });
      });

      window.addEventListener('resize', function () { buildDots(); sync(); });

      slider.tvxRefresh = function () { buildDots(); sync(); };
      buildDots();
      sync();
    }

    function setupTabs(root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('.tvx-tabs__list [role="tab"]'));
      if (!tabs.length) return;

      function activate(tab, focus) {
        tabs.forEach(function (other) {
          var on = other === tab;
          other.setAttribute('aria-selected', on ? 'true' : 'false');
          other.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(other.getAttribute('aria-controls'));
          if (!panel) return;
          panel.hidden = !on;
          if (on) {
            panel.classList.add('is-entering');
            setTimeout(function () { panel.classList.remove('is-entering'); }, 400);
            if (panel.tvxRefresh) panel.tvxRefresh();
          }
        });
        if (focus) tab.focus();
      }

      root.tvxActivate = activate;

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { activate(tab, false); });
        tab.addEventListener('keydown', function (event) {
          var next = null;
          if (event.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          else if (event.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          else if (event.key === 'Home') next = tabs[0];
          else if (event.key === 'End') next = tabs[tabs.length - 1];
          if (!next) return;
          event.preventDefault();
          activate(next, true);
        });
      });
    }

    function init(root) {
      if (!root || root.getAttribute('data-tvx-ready') === '1') return;
      root.setAttribute('data-tvx-ready', '1');
      root.querySelectorAll('.tvx-pslider').forEach(setupSlider);
      setupTabs(root);
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-tvx-pslider]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });

    document.addEventListener('shopify:block:select', function (event) {
      var panel = event.target.closest ? event.target.closest('.tvx-pslider') : null;
      if (!panel) return;
      var root = panel.closest('[data-tvx-pslider]');
      if (!root || !root.tvxActivate) return;
      var tab = root.querySelector('[aria-controls="' + panel.id + '"]');
      if (tab) root.tvxActivate(tab, false);
    });

    document.addEventListener('tvx:tab-change', function () {
      document.querySelectorAll('.tvx-pslider').forEach(function (slider) {
        if (slider.tvxRefresh && slider.offsetHeight > 0) slider.tvxRefresh();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tv-shoppable-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('tv-hero-shoppable')) return;

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const peekCache = new Map();

    class TvHeroShoppable extends HTMLElement {
      connectedCallback() {
        this.spots = Array.from(this.querySelectorAll('[data-spot]'));
        this.stage = this.querySelector('[data-stage]');
        this.media = this.querySelector('.tv-hp__media');
        this.desktopQuery = window.matchMedia('(min-width: 750px)');
        this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        this.spots.forEach((spot) => {
          const area = spot.querySelector('.tv-hp__area');
          if (area) {
            area.addEventListener('click', (event) => {
              if (this.hasAttribute('data-editor')) {
                event.preventDefault();
                return;
              }
              if (this.canHover || spot.classList.contains('is-revealed')) return;
              event.preventDefault();
              this.closeAll();
              spot.classList.add('is-revealed');
              this.fitLabel(area);
            });
            area.addEventListener('mouseenter', () => this.fitLabel(area));
            area.addEventListener('focus', () => this.fitLabel(area));
          }
          spot.addEventListener(
            'click',
            (event) => {
              if (!spot.dataset.peek || this.justDragged) return;
              const fromCard = event.target.closest('.tv-hp__card');
              const fromPin = event.target.closest('[data-spot-toggle]');
              const fromArea = event.target.closest('.tv-hp__area');
              if (!fromCard && !fromPin && !fromArea) return;
              if (this.hasAttribute('data-editor') && !fromCard) return;
              const trigger = fromPin || fromArea || spot.querySelector('[data-spot-toggle]');
              if (!this.openPeek(spot, trigger)) return;
              event.preventDefault();
              event.stopPropagation();
            },
            true
          );
          spot.addEventListener('pointerenter', () => this.prefetch(spot, true));
          spot.addEventListener('touchstart', () => this.prefetch(spot, true), { passive: true });
          spot.addEventListener('focusin', () => this.prefetch(spot, true));
          const toggle = spot.querySelector('[data-spot-toggle]');
          if (!toggle) return;
          toggle.addEventListener('click', (event) => {
            event.stopPropagation();
            if (this.justDragged) return;
            const card = spot.querySelector('.tv-hp__card');
            if (this.canHover && !this.hasAttribute('data-editor') && card) {
              window.location.href = card.href;
              return;
            }
            this.toggle(spot);
          });
          toggle.addEventListener('focus', () => {
            if (toggle.matches(':focus-visible')) this.open(spot);
          });
          if (this.canHover) {
            spot.addEventListener('mouseenter', () => {
              if (this.dragging) return;
              clearTimeout(spot.closeTimer);
              this.open(spot);
            });
            spot.addEventListener('mouseleave', () => {
              spot.closeTimer = setTimeout(() => {
                if (!spot.contains(document.activeElement)) this.close(spot);
              }, 180);
            });
          }
          spot.addEventListener('focusout', (event) => {
            if (!spot.contains(event.relatedTarget)) this.close(spot);
          });
        });
        this.onDocClick = (event) => {
          if (!this.contains(event.target) || !event.target.closest('[data-spot]')) this.closeAll();
        };
        this.onKey = (event) => {
          if (event.key !== 'Escape') return;
          const open = this.spots.find((spot) => spot.classList.contains('is-open'));
          if (!open) return;
          this.close(open);
          const toggle = open.querySelector('[data-spot-toggle]');
          if (toggle) toggle.focus();
        };
        this.onResize = () => this.closeAll();
        document.addEventListener('click', this.onDocClick);
        document.addEventListener('keydown', this.onKey);
        window.addEventListener('resize', this.onResize);
        this.addEventListener('shopify:block:select', (event) => {
          const spot = event.target.closest('[data-spot]');
          if (!spot) return;
          this.open(spot);
          this.spots.forEach((other) => other.classList.toggle('is-picked', other === spot));
        });
        this.addEventListener('shopify:block:deselect', () => {
          this.closeAll();
          this.spots.forEach((spot) => spot.classList.remove('is-picked'));
        });
        this.initPeek();
        if (this.hasAttribute('data-editor') && this.stage) this.initEditor();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onKey);
        window.removeEventListener('resize', this.onResize);
        if (this.onLayout) this.desktopQuery.removeEventListener('change', this.onLayout);
        if (this.peekObserver) this.peekObserver.disconnect();
        document.documentElement.classList.remove('tv-hp-lock');
      }

      initPeek() {
        this.peekDialog = this.querySelector('[data-peek-dialog]');
        if (!this.peekDialog || !this.spots.some((spot) => spot.dataset.peek)) return;
        this.peekPanel = this.peekDialog.querySelector('[data-peek-panel]');
        this.peekBody = this.peekDialog.querySelector('[data-peek-body]');
        this.peekTitleEl = this.peekDialog.querySelector('[data-peek-title]');
        this.peekCountEl = this.peekDialog.querySelector('[data-peek-count]');
        this.peekDialog.querySelector('[data-peek-close]').addEventListener('click', () => this.closePeek());
        this.peekDialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.closePeek();
        });
        this.peekDialog.addEventListener('click', (event) => {
          if (event.target === this.peekDialog) this.closePeek();
        });
        this.peekDialog.addEventListener('close', () => document.documentElement.classList.remove('tv-hp-lock'));
        this.initSwipe();

        const connection = navigator.connection || {};
        const slow = connection.saveData || /2g/.test(connection.effectiveType || '');
        if (slow || !('IntersectionObserver' in window)) return;
        this.peekObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.peekObserver.disconnect();
          const idle = window.requestIdleCallback || ((callback) => setTimeout(callback, 1200));
          idle(() => this.spots.forEach((spot) => this.prefetch(spot, false)));
        });
        this.peekObserver.observe(this);
      }

      prefetch(spot, warmImages) {
        const url = spot.dataset.peek;
        if (!url || !this.peekDialog) return;
        this.load(url)
          .then((data) => {
            if (warmImages && !data.warmed) {
              data.warmed = true;
              data.images.slice(0, 4).forEach((source) => {
                const image = new Image();
                if (source.sizes) image.sizes = source.sizes;
                if (source.srcset) image.srcset = source.srcset;
                image.src = source.src;
              });
            }
          })
          .catch(() => {});
      }

      load(url) {
        if (peekCache.has(url)) return peekCache.get(url);
        const separator = url.includes('?') ? '&' : '?';
        const request = fetch(`${url}${separator}sections=tv-collection-peek`, { credentials: 'same-origin' })
          .then((response) => {
            if (!response.ok) throw new Error(String(response.status));
            return response.json();
          })
          .then((json) => {
            const markup = json['tv-collection-peek'];
            if (!markup) throw new Error('empty');
            const doc = new DOMParser().parseFromString(markup, 'text/html');
            const peek = doc.querySelector('.tv-peek');
            if (!peek) throw new Error('empty');
            const images = Array.from(peek.querySelectorAll('img')).map((img) => ({
              src: img.getAttribute('src'),
              srcset: img.getAttribute('srcset'),
              sizes: img.getAttribute('sizes')
            }));
            return { html: peek.innerHTML, count: Number(peek.dataset.peekCount || 0), images, warmed: false };
          });
        request.catch(() => peekCache.delete(url));
        peekCache.set(url, request);
        return request;
      }

      skeleton() {
        const item = '<li class="tv-peek__item"><span class="tv-peek__media"></span><span class="tv-peek__line"></span><span class="tv-peek__line tv-peek__line--short"></span></li>';
        return `<ul class="tv-peek__grid tv-peek__grid--skeleton" aria-hidden="true">${item.repeat(8)}</ul>`;
      }

      appendFoot(link, label) {
        const foot = document.createElement('div');
        foot.className = 'tv-hp-peek__foot';
        const note = document.createElement('p');
        note.textContent = 'Still looking?';
        const button = document.createElement('a');
        button.className = 'tv-hp__btn tv-hp__btn--primary tv-hp-peek__all';
        button.href = link;
        button.textContent = label;
        foot.append(note, button);
        this.peekBody.appendChild(foot);
      }

      openPeek(spot, trigger) {
        const dialog = this.peekDialog;
        const url = spot.dataset.peek;
        if (!dialog || !url || typeof dialog.showModal !== 'function') return false;
        this.closeAll();
        this.peekTrigger = trigger;
        this.peekToken = url;
        this.peekTitleEl.textContent = spot.dataset.peekTitle || '';
        this.peekCountEl.textContent = '';
        this.peekBody.innerHTML = this.skeleton();
        this.peekBody.scrollTop = 0;
        dialog.setAttribute('aria-busy', 'true');
        dialog.classList.remove('is-closing');
        if (!dialog.open) dialog.showModal();
        document.documentElement.classList.add('tv-hp-lock');

        const link = spot.dataset.peekLink || url;
        const label = spot.dataset.peekMore || 'View all products';
        this.load(url)
          .then((data) => {
            if (this.peekToken !== url || !dialog.open) return;
            this.peekBody.innerHTML = data.html;
            this.peekCountEl.textContent = data.count === 1 ? '1 product' : `${data.count} products`;
            this.appendFoot(link, label);
            dialog.removeAttribute('aria-busy');
          })
          .catch(() => {
            if (this.peekToken !== url || !dialog.open) return;
            this.peekBody.innerHTML = '';
            const message = document.createElement('p');
            message.className = 'tv-peek__empty';
            message.textContent = 'This collection could not be loaded right now.';
            this.peekBody.appendChild(message);
            this.appendFoot(link, label);
            dialog.removeAttribute('aria-busy');
          });
        return true;
      }

      closePeek() {
        const dialog = this.peekDialog;
        if (!dialog || !dialog.open || dialog.classList.contains('is-closing')) return;
        dialog.classList.add('is-closing');
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        setTimeout(() => {
          dialog.classList.remove('is-closing');
          dialog.close();
          this.peekPanel.style.removeProperty('transform');
          this.peekToken = null;
          document.documentElement.classList.remove('tv-hp-lock');
          if (this.peekTrigger && this.peekTrigger.isConnected) this.peekTrigger.focus({ preventScroll: true });
        }, reduce ? 0 : 200);
      }

      initSwipe() {
        const handle = this.peekDialog.querySelector('[data-peek-drag]');
        if (!handle) return;
        handle.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' || this.desktopQuery.matches) return;
          if (event.target.closest('[data-peek-close]')) return;
          const startY = event.clientY;
          let distance = 0;
          this.peekPanel.style.transition = 'none';
          const move = (moveEvent) => {
            distance = Math.max(0, moveEvent.clientY - startY);
            this.peekPanel.style.transform = `translateY(${distance}px)`;
          };
          const end = () => {
            window.removeEventListener('pointermove', move);
            window.removeEventListener('pointerup', end);
            window.removeEventListener('pointercancel', end);
            this.peekPanel.style.removeProperty('transition');
            if (distance > 90) this.closePeek();
            else this.peekPanel.style.removeProperty('transform');
          };
          window.addEventListener('pointermove', move);
          window.addEventListener('pointerup', end);
          window.addEventListener('pointercancel', end);
        });
      }

      toggle(spot) {
        if (spot.classList.contains('is-open')) this.close(spot);
        else this.open(spot);
      }

      open(spot) {
        this.spots.forEach((other) => {
          if (other !== spot) this.close(other);
        });
        const card = spot.querySelector('.tv-hp__card');
        const toggle = spot.querySelector('[data-spot-toggle]');
        if (!card || !toggle) return;
        card.hidden = false;
        spot.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        this.place(spot, card);
      }

      place(spot, card) {
        spot.classList.remove('is-below');
        card.style.removeProperty('--card-shift');
        const bounds = this.media.getBoundingClientRect();
        const gap = 8;
        let rect = card.getBoundingClientRect();
        if (rect.top < bounds.top + gap) {
          spot.classList.add('is-below');
          rect = card.getBoundingClientRect();
        }
        let shift = 0;
        if (rect.left < bounds.left + gap) shift = bounds.left + gap - rect.left;
        else if (rect.right > bounds.right - gap) shift = bounds.right - gap - rect.right;
        if (shift) card.style.setProperty('--card-shift', `${Math.round(shift)}px`);
      }

      fitLabel(area) {
        const label = area.querySelector('.tv-hp__area-label');
        if (!label) return;
        label.style.removeProperty('--label-shift');
        const bounds = this.media.getBoundingClientRect();
        const rect = label.getBoundingClientRect();
        const gap = 8;
        let shift = 0;
        if (rect.left < bounds.left + gap) shift = bounds.left + gap - rect.left;
        else if (rect.right > bounds.right - gap) shift = bounds.right - gap - rect.right;
        if (shift) label.style.setProperty('--label-shift', `${Math.round(shift)}px`);
      }

      close(spot) {
        const card = spot.querySelector('.tv-hp__card');
        const toggle = spot.querySelector('[data-spot-toggle]');
        if (!card || !toggle) return;
        card.hidden = true;
        spot.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }

      closeAll() {
        this.spots.forEach((spot) => {
          this.close(spot);
          spot.classList.remove('is-revealed');
        });
      }

      initEditor() {
        this.marker = document.createElement('div');
        this.marker.className = 'tv-hp__marker';
        this.marker.hidden = true;
        this.marker.innerHTML = '<span class="tv-hp__coords"></span>';
        this.stage.appendChild(this.marker);

        this.spots.forEach((spot) => {
          const data = spot.dataset;
          spot.pos = {
            x: Number(data.x),
            y: Number(data.y),
            w: Number(data.w),
            h: Number(data.h),
            mx: Number(data.mx),
            my: Number(data.my),
            mw: Number(data.mw),
            mh: Number(data.mh),
            custom: data.mobileCustom === 'true'
          };
          const badge = document.createElement('span');
          badge.className = 'tv-hp__coords';
          spot.appendChild(badge);
          spot.badge = badge;
          this.renderCoords(spot);
          spot.addEventListener('pointerdown', (event) => this.startDrag(event, spot));
          spot.addEventListener('click', (event) => {
            if (this.justDragged) event.preventDefault();
          });
        });

        this.stage.addEventListener('dragstart', (event) => event.preventDefault());
        this.stage.addEventListener('click', (event) => {
          if (event.target.closest('[data-spot]')) return;
          this.placeMarker(event);
        });

        this.onLayout = () => {
          this.spots.forEach((spot) => this.renderCoords(spot));
          this.marker.hidden = true;
        };
        this.desktopQuery.addEventListener('change', this.onLayout);
      }

      keys() {
        return this.desktopQuery.matches ? { x: 'x', y: 'y', w: 'w', h: 'h' } : { x: 'mx', y: 'my', w: 'mw', h: 'mh' };
      }

      point(event) {
        const rect = this.stage.getBoundingClientRect();
        return {
          x: clamp(((event.clientX - rect.left) / rect.width) * 100, 0, 100),
          y: clamp(((event.clientY - rect.top) / rect.height) * 100, 0, 100)
        };
      }

      renderCoords(spot) {
        const desktop = this.desktopQuery.matches;
        const k = this.keys();
        const p = spot.pos;
        let text = `${desktop ? 'Desktop' : 'Mobile'}  X ${p[k.x]}  Y ${p[k.y]}`;
        if (spot.classList.contains('tv-hp__spot--area')) text += `  W ${p[k.w]}  H ${p[k.h]}`;
        if (!desktop && !p.custom) text += '\nTurn on: Use a different position on mobile';
        spot.badge.textContent = text;
      }

      placeMarker(event) {
        const p = this.point(event);
        const x = Math.round(p.x);
        const y = Math.round(p.y);
        this.marker.style.setProperty('--px', `${x}%`);
        this.marker.style.setProperty('--py', `${y}%`);
        this.marker.firstElementChild.textContent = `${this.desktopQuery.matches ? 'Desktop' : 'Mobile'}  X ${x}  Y ${y}`;
        this.marker.hidden = false;
      }

      startDrag(event, spot) {
        if (event.button !== 0) return;
        const resize = Boolean(event.target.closest('[data-spot-resize]'));
        const k = this.keys();
        const startX = event.clientX;
        const startY = event.clientY;
        let moved = false;

        const move = (moveEvent) => {
          if (!moved) {
            if (Math.hypot(moveEvent.clientX - startX, moveEvent.clientY - startY) < 4) return;
            moved = true;
            this.dragging = true;
            this.closeAll();
            this.marker.hidden = true;
            this.spots.forEach((other) => other.classList.toggle('is-picked', other === spot));
            spot.classList.add('is-dragging');
          }
          moveEvent.preventDefault();
          const p = this.point(moveEvent);
          if (resize) {
            spot.pos[k.w] = clamp(Math.round(Math.abs(p.x - spot.pos[k.x]) * 2), 4, 100);
            spot.pos[k.h] = clamp(Math.round(Math.abs(p.y - spot.pos[k.y]) * 2), 4, 100);
            spot.style.setProperty(`--${k.w}`, `${spot.pos[k.w]}%`);
            spot.style.setProperty(`--${k.h}`, `${spot.pos[k.h]}%`);
          } else {
            spot.pos[k.x] = Math.round(p.x);
            spot.pos[k.y] = Math.round(p.y);
            spot.style.setProperty(`--${k.x}`, `${spot.pos[k.x]}%`);
            spot.style.setProperty(`--${k.y}`, `${spot.pos[k.y]}%`);
          }
          this.renderCoords(spot);
        };

        const end = () => {
          window.removeEventListener('pointermove', move);
          window.removeEventListener('pointerup', end);
          window.removeEventListener('pointercancel', end);
          if (!moved) return;
          spot.classList.remove('is-dragging');
          this.dragging = false;
          this.justDragged = true;
          setTimeout(() => {
            this.justDragged = false;
          }, 60);
        };

        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', end);
        window.addEventListener('pointercancel', end);
      }
    }

    customElements.define('tv-hero-shoppable', TvHeroShoppable);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tv-tabbed-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function activate(root, tab, focus) {
      var tabs = root.querySelectorAll('.tvx-tabs__tab');
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (!panel) return;
        if (on) {
          if (panel.hidden) {
            panel.hidden = false;
            panel.classList.remove('is-entering');
            void panel.offsetWidth;
            panel.classList.add('is-entering');
          }
        } else {
          panel.hidden = true;
        }
      });
      if (focus) tab.focus();
    }

    function init(root) {
      if (!root || root.__tvxTabs) return;
      var list = root.querySelector('.tvx-tabs__list');
      if (!list) return;
      root.__tvxTabs = true;
      list.addEventListener('click', function (e) {
        var tab = e.target.closest('.tvx-tabs__tab');
        if (tab) activate(root, tab, false);
      });
      list.addEventListener('keydown', function (e) {
        var tabs = Array.prototype.slice.call(list.querySelectorAll('.tvx-tabs__tab'));
        var i = tabs.indexOf(document.activeElement);
        if (i < 0) return;
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); activate(root, next, true); }
      });
    }

    function initAll() { document.querySelectorAll('.tvx-tabs-sec').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);

    document.addEventListener('shopify:block:select', function (e) {
      var el = e.target;
      var root = el && el.closest && el.closest('.tvx-tabs-sec');
      if (!root) return;
      init(root);
      var tab = el.classList.contains('tvx-tabs__tab') ? el : null;
      if (!tab) {
        var panel = el.closest('.tvx-tabs__panel');
        if (panel) tab = root.querySelector('[aria-controls="' + panel.id + '"]');
      }
      if (tab) activate(root, tab, false);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
